module.exports = __webpack_public_path__ + "static/media/20170620-_DSC070607.b0d05d79.jpg";